import { styled } from '@mui/material/styles';

export const StyledHr = styled('div')({
  height: '1px',
  backgroundColor: 'black',
  border: 'none',
  width: '100%',
});
